import { Navigate } from 'react-router-dom';

import CaregiverIdleTimer from './CaregiverIdleTimer';

/**
 * Wraps the authenticated caregiver routes (FECOA-1514).
 *
 * Redirects to the caregiver login when there is no active caregiver session
 * (e.g. after a tab-close clear or an idle logout, since the session lives in
 * sessionStorage), and mounts the 15-minute inactivity timer for the session.
 */
const CaregiverSessionGuard = ({ children }) => {
  const hasSession = !!sessionStorage.getItem('caregiverSession');
  if (!hasSession) {
    return <Navigate to="/caregiver-login" replace />;
  }
  return (
    <>
      <CaregiverIdleTimer />
      {children}
    </>
  );
};

export default CaregiverSessionGuard;
